<template>
<!-- 选择祝福语 -->
  <div class="cepibg82-blessing">
    <img class="bg" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/blessing-bg.png" alt="">
    
    <!-- 祝福语 -->
    <div class="blessing-main">
      <div @click="selectBlessing(item)" v-for="(item,index) in arrList" :key="index" :class="['bd',flashPoint.includes(item)?'on':'',(index+1)%3==0?'mr5':'']">
        <img  :class="['label']"  :src="`https://themes-cdn.xjy.cn/statics/career/images/ceping82/b${index+1}.png`" alt="">
      </div>      
    </div>
    <a :class="['btn',flashPoint.length>=3?'on':'']" @click="nextHandle()" >下一步</a>
  </div>
</template>

<script>
import { getData,saveData } from '@/api/measurement'
import { deepCopy } from "@/utils/tools";
import { shareCon } from "@/utils/wxconfig";
export default {
  data(){
    return{
      arrList:['好奇心','创造性','洞察力','勇敢','勤勉','正直','仁慈','爱','同理心','责任','公平','领导力','自控力','谨慎','谦虚','希望','幽默','热枕'],
      flashPoint:[],
      cid:82,
      blessObj:{},
      mailObject:{}
    }
  },
  methods:{
    // 选择祝福语
    selectBlessing(val){
      if(this.flashPoint.includes(val)){
        this.$forceUpdate();
        this.flashPoint.splice(this.flashPoint.indexOf(val),1);
      }else if(this.flashPoint.length<3){
        this.flashPoint.push(val);
      }else{
        this.$toast('只能选择三个标签');
        return
      }

    },
    // 提交祝福语
    nextHandle(){
      if(this.flashPoint<3){
        this.$toast('请先选择三个闪光点');
        return
      }
      //调用加载中
      this.$emit('loadingHandle',true,"正在提交...");
      let obj = deepCopy(this.blessObj);
      obj['flashPoint'] = this.flashPoint;
      this.mailObject['ceping82'] = obj;
      saveData({
          cid:this.cid,
          data:JSON.stringify(this.mailObject)
      }).then((data)=>{
          //关闭加载中
          this.$emit('loadingHandle',false);
          if (data.code == "10002") {
              this.$toast(data.data.msg || data.msg || data.data.detail);
              return
          }
          this.$router.push('/ceping82_question');
      });
    },
    // 初始化获取数据
    pullData(){
      document.title = "选择三个闪光点";
      //调用加载中
      this.$emit('loadingHandle',true,"正在铺纸ヾ(◍°∇°◍)ﾉﾞ...");
      getData({
        cid:this.cid
      }).then((data)=>{
        //关闭加载中
        this.$emit('loadingHandle',false);
        if (data.code == "10002") {
            this.$toast(data.data.msg || data.msg || data.data.detail);
            return
        }
        if(data.data){
          this.mailObject = JSON.parse(data.data);
          this.blessObj =JSON.parse(data.data) && JSON.parse(data.data).ceping82?JSON.parse(data.data).ceping82:{};
          if(this.blessObj.flashPoint){
            this.flashPoint = this.blessObj.flashPoint;
          }
        }
      });
      shareCon("index", this);
    } 
  },
  created(){
    this.pullData();
  }
}
</script>

<style lang="scss" scoped>
.cepibg82-blessing{
  position: relative;
  padding-top: 525px;
  .bg{
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .blessing-main{
    // width: 580px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .bd{
      border: 3px solid transparent;
      box-sizing: border-box;
      border-radius: 24px;
      padding:8px 6px;
      margin-bottom: 14px;
      margin-right: 5px;
      &:nth-last-child(1),&:nth-last-child(2),&:nth-last-child(3){
        margin-bottom: 60px;
      }
      img.label{
        width: 180px;
        height: auto;
      }
      
    }
    .bd.mr5{
      margin-right: 0;
    }
    .bd.on{
      border: 3px solid #D64624;
    }
  }
  .btn{
    display: block;
    margin: 0 auto;
    width: 300px;
    line-height: 80px;
    height: 80px;
    background: linear-gradient(180deg, #FF855D 0%, #D13E1D 100%);
    box-shadow: 0px 2px 6px 0px rgba(179, 31, 0, 0.43);
    border-radius: 40px;
    display: block;
    text-align: center;
    text-shadow: 0px 2px 4px rgba(221, 41, 0, 0.5);
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    animation: scaleDraw 2s  infinite;
  }
  .btn.on{
      position: fixed;
      bottom: 100px;
      left: 225px;
    }
}
</style>